import { PurchaseOrderStatus } from './purchase-order-status.js';
/** SHIPPED and PARTIALLY_RECEIVED are excluded -- that stock is inbound and still lands here. */
export const TERMINAL_PURCHASE_ORDER_STATUS_IDS = [
    PurchaseOrderStatus.RECEIVED,
    PurchaseOrderStatus.CANCELLED,
];
//# sourceMappingURL=purchase-order-terminal-statuses.js.map